import { Link } from "react-router-dom";
import { Phone, Home as HomeIcon } from "lucide-react";
import SEO from "@/components/SEO";
import { SITE } from "@/data/site";

export default function NotFound() {
  return (
    <>
      <SEO
        title="Page introuvable — DS Serrurier Urgence"
        description="La page demandée n'existe pas. Retour à l'accueil."
        noindex
      />
      <section className="min-h-[70vh] flex items-center bg-cream" data-testid="not-found">
        <div className="container-x text-center">
          <div className="font-mono text-6xl md:text-8xl font-bold mb-4" style={{ color: "var(--brass)" }}>404</div>
          <h1 className="mb-4">Cette page n'existe pas.</h1>
          <p className="text-lg mb-8" style={{ color: "var(--ink-muted)" }}>
            Le lien que vous avez suivi est peut-être obsolète. Revenez à l'accueil ou contactez-nous directement.
          </p>
          <div className="flex flex-wrap justify-center gap-3">
            <Link to="/" className="btn btn-ghost-navy">
              <HomeIcon size={18} /> Retour à l'accueil
            </Link>
            <a href={SITE.telephoneHref} className="btn btn-urgence">
              <Phone size={18} /> Nous appeler
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
